import {
    request,
    requestPublic
} from './request.js'

// 老师列表-分页
export function GetTeacherList(data) {
    return request({
        url: '/api2/FileAdmin/Teacher/GetTeacherList',
        method: 'get',
        params: {
            Name: data.Name,
            QqNumber: data.QqNumber,
            TelNumber: data.TelNumber,
            pageIndex: data.pageIndex,
            pageSize: data.pageSize
        }
    })
}
// 添加老师
export function AddTeacher(data) {
    return request({
        url: '/api2/FileAdmin/Teacher/AddTeacher',
        method: 'post',
        data: data
    })
}
// 编辑老师
export function EditTeacher(data) {
    return request({
        url: '/api2/FileAdmin/Teacher/EditTeacher',
        method: 'post',
        data: data
    })
}
// 删除老师
export function RemoveTeacherById(id) {
    return request({
        url: '/api2/FileAdmin/Teacher/RemoveTeacherById',
        method: 'post',
        params: {
            id:id
        }
    })
}
// 获取老师排班详情列表
export function GetSchedule(data) {
    return request({
        url: '/api2/FileAdmin/Teacher/GetSchedule',
        method: 'get',
        params: {
            ScheduleTime: data.ScheduleTime,
            Category: data.Category
        }
    })
}

// 设置老师排班
export function SetSchedule(data) {
    return request({
        url: '/api2/FileAdmin/Teacher/SetSchedule',
        method: 'post',
        data: data
    })
}
